"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LazyLoadError = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const constants_1 = require("../components/CashierPaymentsWidget/constants");
const LazyLoadError = ({ isModalTheme }) => (react_1.default.createElement("div", { role: "alert", "data-hook": "pw-lazy-load-error" // intentionally not in DataHook.ts to avoid bundling all the data hooks into TPAs bundle
    , 
    // this component gets bundled inside TPAs bundle by their yoshi/webpack config, and .scss might not be supported, thus using css-in-js
    style: Object.assign(Object.assign(Object.assign({}, (!isModalTheme && {
        backgroundColor: `#f4f4f4`,
    })), { padding: `10px 24px`, fontFamily: 'orig_wix_madefor_text_regular, Noto Sans Hebrew, Avenir Next, Helvetica Neue, Helvetica, Arial', fontSize: `15px`, lineHeight: `1.3em` }), (isModalTheme && {
        color: `#f15347`,
    })) }, constants_1.initErrorMessage));
exports.LazyLoadError = LazyLoadError;
exports.LazyLoadError.displayName = 'LazyLoadError';
//# sourceMappingURL=LazyLoadError.js.map